<template>
    <div>
        <Transition name="fade">
            <div
                v-if="isShowBigBetSlip"
                class="overlay ASI_JARVIS_PrlayaSlip_Btn_TapToClose"
                v-on:click="showMiniBetSlip"
            />
        </Transition>
        <Transition name="slide">
            <template v-if="isShowBigBetSlip">
                <EuroBigBetSlip v-if="isEuroSite" />
                <BigSingleModeBetSlip v-else-if="isShowSingleModeBetSlip" />
                <template v-else>
                    <BigParlayBetSlip v-if="isShowParlayBetSlip" />
                    <BigBetBuilderBetSlip v-else-if="isShowBetBuilderBetSlip" />
                </template>
            </template>
            <SingleModeBetSlip v-else-if="isShowSingleModeBetSlip" />
            <template v-else-if="isShowMediumBetSlip">
                <MediumParlayBetSlip v-if="isShowParlayBetSlip" />
                <MediumBetBuilderBetSlip v-else-if="isShowBetBuilderBetSlip" />
            </template>
            <template v-else-if="isShowSingle">
                <DynamicMarketBetSlip v-if="isShowDynamicBetSlip" />
                <EuroSingleBetSlip v-else-if="isShowSingleBetSlip" />
                <OutrightBetSlip v-else-if="isShowOutrightBetSlip" />
            </template>
        </Transition>
    </div>
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, watch } from 'vue';
    import BigBetBuilderBetSlip from '@/components/betSlip/BigBetBuilderBetSlip.vue';
    import BigParlayBetSlip from '@/components/betSlip/BigParlayBetSlip.vue';
    import BigSingleModeBetSlip from '@/components/betSlip/BigSingleModeBetSlip.vue';
    import DynamicMarketBetSlip from '@/components/betSlip/DynamicMarketBetSlip.vue';
    import EuroSingleBetSlip from '@/components/betSlip/EuroSingleBetSlip.vue';
    import MediumBetBuilderBetSlip from '@/components/betSlip/MediumBetBuilderBetSlip.vue';
    import MediumParlayBetSlip from '@/components/betSlip/MediumParlayBetSlip.vue';
    import OutrightBetSlip from '@/components/betSlip/OutrightBetSlip.vue';
    import SingleModeBetSlip from '@/components/betSlip/Single/SingleModeBetSlip.vue';
    import EuroBigBetSlip from '@/indiaSite/components/betSlip/EuroBigBetSlip.vue';
    import { disableScrolling, enableScrolling } from '@/libraries/utils/dom';
    import { useBetSlipStore } from '@/stores/betSlip/betSlipStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';
    import { useRootStore } from '@/stores/rootStore';

    const { isEuroSite } = storeToRefs(useFeatureToggleStore());
    const { isMixParlayMode } = storeToRefs(useRootStore());
    const {
        isShowBetSlip,
        isShowBigBetSlip,
        isShowMediumBetSlip,
        isShowParlayBetSlip,
        isShowBetBuilderBetSlip,
        isShowSingleBetSlip,
        isShowSingleModeBetSlip,
        isShowDynamicBetSlip,
        isShowOutrightBetSlip,
    } = storeToRefs(useBetSlipStore());
    const isShowSingle = computed(() => isShowBetSlip.value && !isMixParlayMode.value);

    const { showMiniBetSlip } = useBetSlipStore();

    watch(isShowBigBetSlip, (showBetSlip) => {
        if (showBetSlip) {
            disableScrolling();
        } else {
            enableScrolling();
        }
    }, { immediate: true });
</script>

<style lang="scss" scoped>
    .slide {
        &-enter-active,
        &-leave-active {
            transition: all 0.3s ease;
        }

        &-enter,
        &-leave-to {
            transform: translateY(100%);
        }

        &-enter-to,
        &-leave {
            transform: translateY(0%);
        }
    }
</style>
